import { render, staticRenderFns } from "./DataSourceForm.vue?vue&type=template&id=479fecc9"
import script from "./DataSourceForm.vue?vue&type=script&lang=js"
export * from "./DataSourceForm.vue?vue&type=script&lang=js"
import style0 from "./DataSourceForm.vue?vue&type=style&index=0&id=479fecc9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports